<template>
  <div>
    <div v-if="isText">
      <h3>{{ text }}</h3>
    </div>
    <div v-else>
      <div class="grid grid-cols-2">
        <div class="w-152">
          <h2><strong>Dimension</strong></h2>
        </div>
        <div class="grid md:flex gap-y-6 md:gap-x-14">
          <h2 class="whitespace-wrap">{{ text }}</h2>
          <div class="flex items-center px-10 py-4 rounded-full bg-light-gray w-fit">
            <label for="unit-input" class="hidden">Unit</label>
              <select
                id="unit-input"
                v-model="unit"
                class="focus:outline-none text-14 bg-light-gray">
                <option
                  v-for="option in options"
                  :key="option"
                  :value="option">
                  {{ option }}
                </option>
              </select> 
          </div> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const UNITS = {
  cm: 2.54,
  inches: 1,
}

export default {
  props: {
    height: { default: null },
    isText: { type: Boolean, default: false },
    width: { default: null },
    depth: { default: null },
  },

  data () {
    return {
      unit: 'inches'
    }
  },

  methods: {
    getDimension (dimension) {
      let value = (this.$props[dimension] * UNITS[this.unit]).toLocaleString()
      let symbol = this.unit === 'inches' ? '"' : 'cm'

      return ` ${value}${symbol} `
    }
  },

  computed: {
    text () {
      let texts = []
      texts.push(this.getDimension('height'))
      texts.push(this.getDimension('width'))

      if (this.depth > 0) {
        texts.push(this.getDimension('depth'))
      }

      return texts.join('x')
    },

    options () {
      return Object.keys(UNITS)
    }
  }
}

</script>

